module.exports = __webpack_public_path__ + "img/yzg2.222db191.jpg";